import { render, staticRenderFns } from "./PartNavigator.vue?vue&type=template&id=61ca6fbc&scoped=true"
import script from "./PartNavigator.vue?vue&type=script&lang=js"
export * from "./PartNavigator.vue?vue&type=script&lang=js"
import style0 from "./PartNavigator.vue?vue&type=style&index=0&id=61ca6fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ca6fbc",
  null
  
)

export default component.exports